import { useNavigate } from 'react-router-dom';

const useCustomNavigate = () => {
        
    const navigate = useNavigate();

    const Navigate = (path, params) => {
        navigate(path, params);
    }

    return Navigate;
}

export default useCustomNavigate;